import { c as _c } from "react/compiler-runtime";
import { ChangeEvent, useCallback } from 'react';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
type SortFilterContentProps<SortKey extends string = string> = {
  className?: string;
  onChange: (sort: SortKey) => void;
  selectedOption: SortKey;
  sortOptions: Record<SortKey, string>;
};
export const SortFilterContent = t0 => {
  const $ = _c(16);
  const {
    className,
    onChange,
    selectedOption,
    sortOptions
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== onChange) {
    t1 = event => {
      onChange(event.currentTarget.value as SortKey);
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("filter.a11y.sortLabel");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <legend className="!sr-only">{t2}</legend>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== sortOptions) {
    t4 = Object.entries(sortOptions);
    $[6] = sortOptions;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== handleChange || $[9] !== selectedOption || $[10] !== t4) {
    t5 = t4.map(t6 => {
      const [key, label] = t6;
      const isSelected = selectedOption === key;
      return <label key={key} className="group flex cursor-pointer items-center"><input type="radio" className="peer sr-only" name={label} value={key} checked={isSelected} onChange={handleChange} /><span aria-hidden={true} className={clsx("relative block size-5 shrink-0 rounded-full border-2 border-black group-hover:border-neutral-800 peer-focus-visible:shadow-[0_0_0_2px_var(--white)] peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-focus", isSelected && "after:absolute after:inset-[calc(--spacing(1)_*_0.75)] after:size-2.5 after:rounded-full after:bg-black group-hover:after:bg-neutral-900")} /><span className="ml-2 whitespace-nowrap group-hover:text-neutral-800">{label}</span></label>;
    });
    $[8] = handleChange;
    $[9] = selectedOption;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== className || $[13] !== t3 || $[14] !== t5) {
    t6 = <fieldset className={className}>{t3}{t5}</fieldset>;
    $[12] = className;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};